import { IsNotEmpty, IsString, MaxLength, IsInt, IsUUID } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class ManuscriptEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsNotEmpty()
    @IsString()
    content: string;

    @IsNotEmpty()
    @IsInt()
    type: number;

    @IsNotEmpty()
    @IsUUID()
    product: string;

}
